:host{display:flex;flex-direction:column;gap:8px;padding:16px 8px;overflow-y:auto;overflow-x:hidden}mat-divider{margin-bottom:16px}
/*# sourceMappingURL=region-of-interest-settings.component.css.map */
